import { AxiosError, AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { SelfBookingAppointmentTypeRetrieve } from 'types/generated';
import { client } from 'utils/api-client';

import { ErrorMessage } from '../../types';

export default function useSelfBookingAppointmentType(
  appointmentTypeId: string | null,
): UseQueryResult<AxiosResponse<SelfBookingAppointmentTypeRetrieve>, AxiosError<ErrorMessage>> {
  return useQuery(
    ['appointment-type-self-booking', appointmentTypeId],
    () => client.get(`appointment-self-booking/${appointmentTypeId}/`),
    {
      enabled: !!appointmentTypeId,
    },
  );
}
